import { useState } from 'react';

import { Button } from '../../../../../components/Clickables/Buttons/Button';
import { InternalLink } from '../../../../../components/Clickables/InternalLink/InternalLink';
import { ChevronDownIcon } from '../../../../../components/Icons/ChevronDownIcon';
import { ChevronUpIcon } from '../../../../../components/Icons/ChevronUpIcon';
import { Text } from '../../../../../components/Text/Text';
import { ISEOWaterWithTypeList, WaterType } from '../../../../../constants/fishingWaters/constants';
import { getFishingWaterUrl } from '../../../../../helpers/urls';

interface IProps {
  waters: ISEOWaterWithTypeList;
  selectedWaterType: WaterType;
  thisWaterType: WaterType;
}

export const WaterLinks = ({ waters, selectedWaterType, thisWaterType }: IProps) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const headingText = `Top spots in the US for ${thisWaterType} fishing`;
  return (
    <div
      className={`border-twilight bg-sea-foam rounded-b-lg border-x-2 border-b-2 p-4 ${selectedWaterType === thisWaterType ? 'block' : 'hidden'}`}
    >
      <Text className="mx-2 p-2 text-center sm:m-4">{headingText}</Text>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 md:grid-cols-5">
        {waters.waters.map((water, index) => {
          const { external_id: externalId, water_name: displayName, State } = water;
          const catchData = `${water.catches} - total catches`;
          return (
            <InternalLink
              to={getFishingWaterUrl(externalId, displayName)}
              className={`bg-twilight flex flex-col rounded-lg p-3 ${index > 4 && !showMore ? 'hidden' : ''} `}
              key={externalId}
            >
              <span>{displayName}</span>
              <span className="text-midnight mt-2 text-xs">{State}</span>
              <span className="text-midnight mt-1 text-xs">{catchData}</span>
            </InternalLink>
          );
        })}
      </div>
      <div className="mt-1 flex h-full justify-center">
        {!showMore ? (
          <Button
            variant="textPrimary"
            onClick={() => {
              setShowMore(true);
            }}
            className="size-10"
          >
            <ChevronDownIcon size={28} />
          </Button>
        ) : (
          <Button
            variant="textPrimary"
            onClick={() => {
              setShowMore(false);
            }}
            className="size-10"
          >
            <ChevronUpIcon size={28} />
          </Button>
        )}
      </div>
    </div>
  );
};
